export default (state = {}, action) => {
    let { type, payload } = action
    switch (type) {
        case 'HUNT_PLANNER_ACTIVE_LAYER_DETAILS':
            return payload
        case 'LOGOUT':
            return null
        default:
            return state
    }
}
